// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.multimedia-container[data-v-60c6b7f2]{\n    border-radius: 10px;\n    width: 350px;\n    height: 200px;\n    flex-shrink: 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
